import React, { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import "../../styles/styles.css";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";

const StudyDetails = ({ viewportData, isMPR = false}) => {
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { t } = useTranslation();

  const [localDescription, setLocalDescription] = useState(viewportData?.studyDescription || "");

  const updateDescriptionFromParent = (newDescription) => {
    setLocalDescription(newDescription);
  };

  window.updateStudyDescription = updateDescriptionFromParent;

  useEffect(() => {
    if (viewportData?.studyDescription !== undefined) {
      setLocalDescription(viewportData.studyDescription);
    }
  }, [viewportData?.studyDescription]);

  return (
    <>
      <div className="viewport-overlay-study" style={{maxWidth:isMPR ? "200px" : ""}}>
        {viewportData && (
          <>
            <CustomToolTipHost content={localDescription || "-"} id="overlay-study-id">
              <span style={{ lineHeight: "15px" }}>
                <span className="viewport-overlay-key">
                  {localDescription || "-"}
                </span>
              </span>
            </CustomToolTipHost>
            <CustomToolTipHost content={getConsistentDateFormat(viewportData?.studyDate)} id="overlay-study-date">
              <span style={{ lineHeight: "20px" }}>
                <span className="viewport-overlay-value">
                  {getConsistentDateFormat(viewportData?.studyDate)}
                </span>
              </span>
            </CustomToolTipHost>
            


            {/* <div>Study Id: {studyResponseData?.id}</div>
            <div>Description: {studyResponseData?.studyDescription}</div>
            <div>Study Date: {studyResponseData?.studyDateDisplay}</div> */}
            {/* <div>Study Id: {patientResponseData?.id}</div>
            <div>Description: {patientResponseData?.studyDescription}</div>
            <div>Study Date: {patientResponseData?.studyDateDisplay}</div> */}
          </>
        )}
      </div>
    </>
  );
};

export default StudyDetails;
